module.exports = __webpack_public_path__ + "media/seher_1.1c.fe824e44.mp3";